import React, { useContext } from 'react'
import { CarOrderingContext } from "../../CarOrdering";

export default function Price({ price, showSuffix = true, bold = false, hideEmpty = false, className = 'price' }) {
  const {
    lang,
    strings,
  } = useContext(CarOrderingContext)

  const MaybeBold = bold ? 'strong' : React.Fragment
  const suffix = strings?.price?.suffix ?? ' kr.'

  if (price <= 0 && hideEmpty === true) {
    return null
  }

  return (
    <div className={className}>
      <MaybeBold>{new Intl.NumberFormat(lang).format(price)}</MaybeBold>
      {' '}
      {showSuffix && suffix}
    </div>
  )
}
